import * as Yup from "yup";
export interface ImageSearchRequestModel {
  probill: string,
  documentId: string,
  customer: string,
  bol: string,
  po: string,
  docType: string,
  location: string,
  status: string,
  from: string | null,
  to: string | null,
  limit: number,
  isRestoreImage: boolean,
}

export interface ImageSearchValidationModel {
  probill: string,
  documentId: string,
  customer: string,
  bol: string,
  po: string,
  from: string | null,
  to: string | null,
  docType: string,
  location: string,
  status: string,
}

export interface ThumbnailUpdateModel {
  docId: number,
  probill: number | null | undefined,
  docTypeId: string,
  docIndexUsr: string | null | undefined,
  docIndexDte: string | null | undefined,
  indexData: IndexData | null | undefined,
  docLockedUsr: string | null | undefined,
  docLockDte: string | null | undefined,
  docStatId: number
}

interface IndexData {
  MCUSNM: string | null | undefined,
  MCUSNO: number | null | undefined,
  PBBOL2: string | null | undefined,
  PBPO: string | null | undefined
}

export const imageSearchValidationSchema: Yup.ObjectSchema<ImageSearchValidationModel> = Yup.object().shape({
  probill: Yup.string()
    .test("valid-length", "7 or 8 digit numbers required", (value) => {
      if (!value) return true;
      return /^\d{7,8}$/.test(value);
    }),

  customer: Yup.string()
    .test("valid-customer", "3 - 8 digits required", (value) => {
      if (!value) return true;
      return /^\d{3,8}$/.test(value);
    }),

  bol: Yup.string()
    .test("valid-bol", "At least 4 characters required", (value) => {
      if (!value) return true;
      return value.length >= 4;
    }),

  po: Yup.string()
    .test("valid-po", "At least 3 characters required", (value) => {
      if (!value) return true;
      return value.length >= 3;
    }),

  documentId: Yup.string()
    .test("valid-documentId", "8 - 10 digits required", (value) => {
      if (!value) return true;
      return /^\d{8,10}$/.test(value);
    }),

  from: Yup.string()
    .nullable()
    .test("is-valid-from", "Start and end dates required", function (value) {
      const { from, to } = this.parent;
      return (!from && !to) || (from && to);
    }),

  to: Yup.string()
    .nullable()
    .test("is-valid-to", "Start and end dates required", function (value) {
      const { from, to } = this.parent;
      return (!from && !to) || (from && to);
    }),

  location: Yup.string().nullable(),
  status: Yup.string().nullable(),
  docType: Yup.string().nullable()
}).defined();